import { SettingsContainer } from '@/modules/Settings';

const Settings = (): JSX.Element => <SettingsContainer />;

export default Settings;
